import Board from './components/Layout/Board';

function App() {
	return (
		<div className='App'>
			<Board />
		</div>
	);
}

export default App;
